import React from 'react';
import { ThemeProvider} from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { SessionTimeoutProvider } from './components/SessionTimeout';
import { colors } from './utils/theme';
import { LayoutProvider } from './layout/context';
import { store } from "./store/store";

export const ProviderComposer = ({ contexts, children }: any): JSX.Element =>
  contexts.reduceRight((kids, parent) => {
    return React.cloneElement(parent, {
      children: kids,
    });
  }, children);

interface Props {
  children: React.ReactNode;
  theme: any;
}

const ContextProvider: React.FC<Props> = ({ theme, children }) => (
  <ProviderComposer
    contexts={[
      <Provider store={store}>{children}</Provider>,
      <StyledThemeProvider theme={{ ...theme, colors }} />,
      <BrowserRouter/>,
      <SessionTimeoutProvider children={children} />,
      <LayoutProvider children={children} />,
    ]}
  >
    <ThemeProvider theme={{ ...theme, colors }}>{children}</ThemeProvider>
  </ProviderComposer>
);

export default ContextProvider;
